/*! StartNoStringValidationRegion enum constants */
export enum RuleType {
  Command = "command",
  Lookup = "lookup",
  Property = "property",
  ProposedValue = "proposedValue",
  Validation = "validation",
}
/*! EndNoStringValidationRegion */
